<template>
  <div class="main text-center">
    <div class="wrap-particles">
      <div class="main-content">
        <div class="container d-flex justify-content-center align-items-center">
          <div class="p-4">
            <img src="@/assets/logo-white.png" class="w-sm-100 w-md-75 w-lg-50 my-2" />
            <div v-if="hasPermission">
              <div v-if="hasMotion">
                <div class="d-flex justify-content-center my-2">
                  <input
                    v-model="gamePIN"
                    type="number"
                    pattern="\d*"
                    :maxLength="PINLength"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    class="rounded-0 text-uppercase form-control form-control-lg text-center w-sm-75 w-md-50 w-lg-25"
                    placeholder="Game PIN"
                  />
                </div>
                <div class="d-flex justify-content-center my-2">
                  <b-button
                    class="rounded-0 text-uppercase btn btn-danger btn-lg btn-block w-sm-75 w-md-50 w-lg-25"
                    :disabled="isDisabled"
                    @click="joinGame"
                  >Enter</b-button>
                </div>
                <p class="text-white">OR</p>
              </div>
              <div v-else>
                <h5
                  class="text-white"
                >Sorry, this game is not compatible with your device or browser.</h5>
                <p class="text-white">But you can also create new game.</p>
              </div>
            </div>
            <div v-else class="d-flex justify-content-center my-2">
              <b-button
                @click="permission"
                class="rounded-0 text-uppercase btn btn-light btn-lg btn-block w-sm-75 w-md-50 w-lg-25"
              >Play</b-button>
            </div>

            <div class="d-flex justify-content-center my-2">
              <!--  -->
              <!-- <b-button to="/create"
                class="rounded-0 text-uppercase btn btn-light btn-lg btn-block w-sm-75 w-md-50 w-lg-25">
                Create New Game
              </b-button>-->
              <!--  -->

              <b-button
                to="/create/mining"
                class="rounded-0 text-uppercase btn btn-light btn-lg btn-block w-sm-75 w-md-50 w-lg-25"
              >Create New Game</b-button>
            </div>
          </div>
        </div>
      </div>

      <vue-particles
        color="#ffffff"
        :particleOpacity="0.3"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="5"
        :lineLinked="false"
        :moveSpeed="1"
        :hoverEffect="false"
        :clickEffect="false"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      hasMotion: false,
      hasPermission: false,
      PINLength: 6,
      gamePIN: ""
    };
  },
  mounted() {},
  computed: {
    isDisabled() {
      return !(this.gamePIN.length == this.PINLength);
    },
    isPortrait() {
      return window.innerHeight > window.innerWidth;
    }
  },
  methods: {
    permission: function() {
      let self = this;

      DeviceMotionEvent.requestPermission().then(response => {
        if (response == "granted") {
          window.addEventListener("devicemotion", function(event) {
            if (
              event.rotationRate.alpha ||
              event.rotationRate.beta ||
              event.rotationRate.gamma
            )
              self.hasMotion = true;
          });
        }
      });

      self.hasPermission = true;
    },
    joinGame: function() {
      let self = this;
      self.$router.replace("/join/" + self.gamePIN);
    }
  }
};
</script>

<style scoped>
.main {
  width: 100vw;
  min-height: 100vh;
  background-color: #000;
}

.container {
  width: 100vw;
  min-height: 100vh;
}
</style>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#particles-js {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.wrap-particles {
  overflow: hidden;
  position: relative;
  min-height: 100vh;
  width: 100vw;
  display: flex;
}

.main-content {
  width: 100vw;
  z-index: 999;
}

/* mobile */
.w-sm-25 {
  width: 25% !important;
}

.w-sm-50 {
  width: 50% !important;
}

.w-sm-75 {
  width: 75% !important;
}

.w-sm-100 {
  width: 100% !important;
}

.h-sm-25 {
  height: 25% !important;
}

.h-sm-50 {
  height: 50% !important;
}

.h-sm-75 {
  height: 75% !important;
}

.h-sm-100 {
  height: 100% !important;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .w-md-25 {
    width: 25% !important;
  }

  .w-md-50 {
    width: 50% !important;
  }

  .w-md-75 {
    width: 75% !important;
  }

  .w-md-100 {
    width: 100% !important;
  }

  .h-md-25 {
    height: 25% !important;
  }

  .h-md-50 {
    height: 50% !important;
  }

  .h-md-75 {
    height: 75% !important;
  }

  .h-md-100 {
    height: 100% !important;
  }
}

/* desktop */
@media only screen and (min-width: 960px) {
  .w-lg-25 {
    width: 25% !important;
  }

  .w-lg-50 {
    width: 50% !important;
  }

  .w-lg-75 {
    width: 75% !important;
  }

  .w-lg-100 {
    width: 100% !important;
  }

  .h-lg-25 {
    height: 25% !important;
  }

  .h-lg-50 {
    height: 50% !important;
  }

  .h-lg-75 {
    height: 75% !important;
  }

  .h-lg-100 {
    height: 100% !important;
  }
}
</style>
